import { render, staticRenderFns } from "./ConnectionSuccess.vue?vue&type=template&id=0150455c"
import script from "./ConnectionSuccess.vue?vue&type=script&lang=js"
export * from "./ConnectionSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports